<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog width="450" v-model="searchModal">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-magnify</v-icon>
              <span class="modal-title-text mr-2">جستجو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="12">
              <v-text-field type="text" v-model="searchText" dense clearable clear-icon="mdi-close-circle-outline"
                outlined v-on:keyup.enter="search()" label="عنوان" class="input-label"
                prepend-inner-icon="mdi-text mdi-18px" tabindex="1"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" v-model="searchCode" dense clearable clear-icon="mdi-close-circle-outline"
                outlined v-on:keyup.enter="search()" label="کد" class="input-label"
                prepend-inner-icon="mdi-barcode mdi-18px" tabindex="2"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="allDrugGroupsForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="3" dense
                outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                label="گروه دارویی" v-model="searchDrugGroupId" autocomplete="off"
                prepend-inner-icon="mdi-pill-multiple mdi-18px" style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="allUnitsForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="4" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="واحد دارو"
                v-model="searchUnitId" autocomplete="off" prepend-inner-icon="mdi-medication mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
            جستجو
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="900" v-model="isDrugVehicleTypeModalOpen">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-car-multiple mdi-24px</v-icon>
              <span class="modal-title-text mr-2">تخصیص وسیله نقلیه به دارو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col>
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="9" class="flex items-center">
                      <app-title-header title="وسایل نقلیه" />
                    </v-col>
                    <v-col cols="3" class="pr-0">
                      <v-btn dark color="darkColor" block rounded @click="addAllVehicleTypes">
                        انتخاب همه
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <app-box max-height="190px" outlined="">
                    <v-chip-group column v-if="allVehicleTypes?.length">
                      <v-chip v-for="vehicleTypes in allVehicleTypes" :key="vehicleTypes?.id" :ripple="false" label dark
                        close :disabled="haveDublicated(vehicleTypes?.id)" close-icon="mdi-plus mdi-24px"
                        class="all-chip" @click:close="addNewVehicleType(vehicleTypes)">
                        {{ vehicleTypes?.title }}
                      </v-chip>
                    </v-chip-group>
                    <div v-else>وسیله نقلیه وجود ندارد</div>
                  </app-box>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="9" class="flex items-center">
                      <app-title-header title="وسایل نقلیه انتخابی" />
                    </v-col>
                    <v-col cols="3" class="pr-0">
                      <v-btn dark color="darkColor" block rounded @click="deleteAllVehicleTypes">
                        حذف همه
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <app-box max-height="190px" outlined="">
                    <v-chip-group column v-if="allSelectedVehicleTypes?.length">
                      <v-chip v-for="{ title, id } in allSelectedVehicleTypes" :key="id" :ripple="false" label dark
                        close close-icon="mdi-close mdi-24px" color="darkColor" @click:close="deleteVehicleType(id)">
                        {{ title }}
                      </v-chip>
                    </v-chip-group>
                    <div v-else>وسیله نقلیه وجود ندارد</div>
                  </app-box>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" dark rounded class="normal-letter-spacing px-12" @click="addRangeOfAttachments">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined class="normal-letter-spacing px-10"
            @click="closeDrugVehicleTypeModal()">
            انصراف
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">مدیریت دارو</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-col cols="1" class="mr-n3">
              <v-btn class="mx-2 mt-3 mr-n16" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
                <v-icon dark>mdi-filter mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" class="mr-n16 mt-6" v-if="isSearch">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()" class="mr-n16">
                    mdi-filter-remove mdi-18px
                  </v-icon>
                </template>
                <span>حذف فیلتر ها</span>
              </v-tooltip>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
                class="mt-3 normal-letter-spacing ml-3">
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن دارو
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="body-card card-width">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table fixed-header :headers="drugManagmentInformationTableHeaders"
                          :items="drugFilteredList" :page.sync="page" :items-per-page="drugFilteredList.length"
                          height="62vh" :hide-default-footer="true" multi-sort class="elevation-0">
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                                  @click="openDrugVehicleTypeModal(item.id)" v-bind="attrs" v-on="on">
                                  mdi-car-multiple
                                </v-icon>
                              </template>
                              <span>تخصیص وسیله نقلیه به دارو</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-1" color="iconColor" style="cursor: pointer"
                                  @click="goToMoreInformation(item.id)" v-bind="attrs" v-on="on">
                                  mdi-information
                                </v-icon>
                              </template>
                              <span>اطلاعات تکمیلی</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mx-1" color="iconColor" style="cursor: pointer"
                                  @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                                  mdi-pencil
                                </v-icon>
                              </template>
                              <span>ویرایش</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                                  @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>حذف</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <pagination-component ref="pagination">
                <div slot="action">
                  <v-card elevation="0">
                    <v-pagination class="mt-8" circle v-model="page" color="lightColor" :length="totalPages"
                      :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                      @next="next()" @previous="previous()" @input="input()"></v-pagination>
                  </v-card>
                </div>
              </pagination-component>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import confirmDialog from '@/components/ConfirmDialog.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import AppTitleHeader from '@/components/app/TitleHeader.vue';
import AppBox from '@/components/app/box.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import drugMixin from '@/Mixins/BaseInformation/DrugMixin';
import drugHelper from '@/Helpers/BaseInformation/Drug/DrugHelper';
import UnitMixin from '@/Mixins/BaseInformation/UnitMixin';
import DrugGroupMixin from '@/Mixins/BaseInformation/DrugGroupMixin';
import VehicleTypeMixin from '@/Mixins/BaseInformation/VehicleTypeMixin';
import DrugVehicleTypeMixin from '@/Mixins/BaseInformation/DrugVehicleType.mixin';
export default {
  name: 'DrugManagment',
  title: 'دارو',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    PaginationComponent,
    AppTitleHeader,
    AppBox,
  },
  mixins: [
    pagination,
    ShearedMixin,
    drugMixin,
    drugHelper,
    snackBar,
    ShearedHelper,
    DrugGroupMixin,
    UnitMixin,
    VehicleTypeMixin,
    DrugVehicleTypeMixin,
  ],
  created() {
    this.$root.$refs.DrugManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getListOfDrugsWithPagination();
      this.getListOfUnits();
      this.getListOfDrugGroupsForOther();
    },
    previous: function () {
      this.getListOfDrugsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getListOfDrugsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getListOfDrugsWithPagination();
      this.$refs.pagination.page = this.page;
    },
  },
  computed: {
    drugFilteredList() {
      return this.drugPaginationList.filter((u) => {
        return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
      });
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
